import styles from './ProfileCard.module.scss';
import { Link } from 'react-router-dom';

export default function ProfileCard({isArrow, firstName, lastName, avatar,id, username}) { 
  return (
    <div>    
        <div className={`d-flex ${styles.profileCard} align-items-center`}>
            {
            avatar 
                ? <img src={`${process.env.REACT_APP_API_URL}${avatar}`} className={`img-fluid me-2 ${styles.userImage}`} />
                : <i className={`bi bi-person me-2 ${styles.userIcon}`}></i>
            }
            <div className={`${styles.userName} flex-grow-1 `}>
                { firstName &&
                    <Link to={`/vendor/${id}`}
                        className='d-block'>
                        <span>
                            {firstName}{' '}{lastName}
                        </span>
                    </Link>           
                }
                {username &&
                    <Link  to={`/vendor/${id}`}
                        className={`${styles.username} d-block`}>
                        {username}
                    </Link>
                }

            </div>
            {
                isArrow && (
                    <Link to={`/vendor/${id}`} className={`justifty-content-between`}>
                        <i className='bi bi-chevron-right'></i>
                    </Link>
                )
            }
        </div>
    </div>
  )
}
